import {
  Avatar,
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Space,
} from "antd";
import { Rule } from "antd/lib/form";
import { useForm } from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { shopApi } from "api/shop.api";
import { workshopsApi } from "api/workshop.api";

import dayjs from "utils/dayjs";
import React, { useEffect, useState } from "react";
import { GuestType } from "types/guest";
import { ModalStatus } from "types/modal";
import { Shop } from "types/shop";
const rules: Rule[] = [{ required: true }];

export const UpdateShopModal = ({
  visible,
  status,
  shopInfo,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  shopInfo?: Partial<Shop>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [guestType, setGuestType] = useState<GuestType>(
    shopInfo?.guestType || GuestType.Guest
  );

  useEffect(() => {
    if (visible) {
      if (shopInfo?.workshops) {
        const bookingUnix =
          shopInfo?.workshops[shopInfo?.workshops?.length - 1]?.bookingDate;
        form.setFieldsValue({
          name: shopInfo?.workshops[shopInfo?.workshops?.length - 1]?.name,
          phone: shopInfo?.workshops[shopInfo?.workshops?.length - 1]?.phone,
          businessArea: shopInfo?.businessArea,
          bookingDate: dayjs(bookingUnix),
          shopName: shopInfo.name,
          chapterName: shopInfo?.chapterName,
          type: shopInfo.guestType,
        });
      }
    }
  }, [visible, shopInfo]);

  useEffect(() => {
    if (status == "create") form.resetFields();
  }, [status]);

  const handleSubmitForm = async () => {
    await form.validateFields();
    setLoading(true);
    const dataPost = form.getFieldsValue();
    const workshops = {
      name: dataPost.name,
      phone: dataPost.phone,
      bookingDate: dataPost.bookingDate.format("YYYY-MM-DD"),
    };
    const shop = {
      name: dataPost.shopName,
      businessArea: dataPost.businessArea,
      chapterName: dataPost.chapterName,
    };
    const workShopId =
      shopInfo?.workshops &&
      shopInfo?.workshops[shopInfo.workshops?.length - 1].id;
    try {
      switch (status) {
        case "update":
          await shopApi.update(shopInfo?.id || 0, { shop });
          await workshopsApi.update(workShopId || 0, {
            workshops,
          });
          message.success("Đã chỉnh sửa thông tin doanh nghiệp");
          break;

        //create
        default:
          await shopApi.create({ businessType: dataPost });
          message.success("Đã thêm mới thông tin doanh nghiệp");
          break;
      }

      onSubmitOk();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={(status == "create" ? "Thêm" : "Chỉnh sửa") + " thông tin"}
      confirmLoading={loading}
      onOk={handleSubmitForm}
      style={{ top: 20 }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ type: shopInfo?.guestType || GuestType.Guest }}
      >
        <FormItem label="Phân loại" name="type" rules={rules}>
          <Radio.Group onChange={(e) => setGuestType(e.target.value)}>
            <Radio value={GuestType.Guest}>Khách mời</Radio>
            <Radio value={GuestType.Chapter}>Khách thăm</Radio>
          </Radio.Group>
        </FormItem>
        <FormItem label="Tên" name="name" rules={rules}>
          <Input placeholder="" />
        </FormItem>
        <FormItem label="Số điện thoại" name="phone" rules={rules}>
          <Input placeholder="" />
        </FormItem>
        <FormItem label="Tên doanh nghiệp" name="shopName" rules={rules}>
          <Input placeholder="" />
        </FormItem>
        <FormItem label="Lĩnh vực kinh doanh" name="businessArea" rules={rules}>
          <Input placeholder="" />
        </FormItem>
        {guestType == GuestType.Chapter && (
          <FormItem label="Tên chapter" name="chapterName">
            <Input placeholder="" />
          </FormItem>
        )}

        <FormItem label="Thời gian họp" name="bookingDate" rules={rules}>
          <DatePicker
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
            inputReadOnly={true}
            open={false}
            allowClear={false}
          />
        </FormItem>
      </Form>
    </Modal>)
  );
};
